import styled from 'styled-components';

import { SimpleButton } from '@components/formStyles';
import { PaletteColor } from '@utils/types';

export const HeaderItem = styled.li<{
  isTransparentHeader?: boolean;
  isMegaMenuVisible?: boolean;
}>`
  display: flex;
  position: relative;
  height: 45px;
  cursor: pointer;
  transition: all 0.7s;

  z-index: 2;

  & > a {
    font-size: 18px;
    font-weight: 600;
    text-decoration: none;
    color: ${({ theme, isTransparentHeader }) =>
      isTransparentHeader
        ? theme.palette.D400
        : theme.palette.darkGrey} !important;
    text-decoration: none !important;

    height: 100%;
    display: flex;
    align-items: center;
    &:hover {
      color: ${({ theme, isTransparentHeader }) =>
        isTransparentHeader
          ? theme.palette.D400
          : theme.palette.darkGrey} !important;
    }
  }
`;

export const HeaderRegularItem = styled.li<{
  isTransparentHeader?: boolean;
  isMargin?: boolean;
}>`
  position: relative;
  height: 100%;

  & > a {
    font-size: 18px;
    font-weight: 600;
    text-decoration: none;
    color: ${({ theme, isTransparentHeader }) =>
      isTransparentHeader
        ? theme.palette.D400
        : theme.palette.darkGrey} !important;
    text-decoration: none !important;
    height: 100%;
    display: flex;
    align-items: center;
    margin-bottom: ${({ isMargin }) => (isMargin ? 3 : 0)}px !important;
    &:hover {
      color: ${({ theme, isTransparentHeader }) =>
        isTransparentHeader
          ? theme.palette.D400
          : theme.palette.darkGrey} !important;
    }
  }
`;

export const Container = styled.div`
  width: 100%;
  min-width: 260px;
  height: auto;
  position: relative;
  z-index: 1000;
`;

export const Item = styled.div`
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.white};
  padding-left: 15px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.lightBlueGrey};
  cursor: pointer;
  &:first-child {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  &:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  &:hover {
    background-color: ${({ theme }) => theme.palette.whiteSmoke};
  }
  &:active {
    background-color: ${({ theme }) => theme.palette.white};
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    &:first-child {
      border-radius: 0;
    }

    &:last-child {
      border-radius: 0;
    }
  }
`;

export const Text = styled.span`
  font-size: 18px !important;
  margin-left: 15px;
  font-weight: 400 !important;
  margin-bottom: 5px;
  color: ${({ theme }) => theme.palette.darkGrey} !important;
  align-self: center;
`;
export const StyledProfileName = styled(SimpleButton)<{
  textColor: PaletteColor;
}>`
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme, textColor }) => theme.palette[textColor]};
  margin-right: 4px;
`;
export const LabelText = styled.div`
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.darkGrey} !important;
  -webkit-text-decoration: none !important;
  text-decoration: none !important;
  height: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 0px !important;
  align-items: center;
  display: flex;
`;
export const HeaderText = styled.div`
  cursor: pointer !important;
  display: inline-block !important;
  color: ${({ theme }) => theme.palette.D400} !important;
  font-size: 18px !important;
  font-weight: 600 !important;
`;
export const DisplayMegaMenu = styled.div`
  display: none;
`;
